export const limitsConsentICoreName = 'RGLimitsConsent';
